import { render, staticRenderFns } from "./OtherUserGroupTypeList.vue?vue&type=template&id=7d400d8f&scoped=true&lang=pug"
import script from "./OtherUserGroupTypeList.vue?vue&type=script&lang=ts"
export * from "./OtherUserGroupTypeList.vue?vue&type=script&lang=ts"
import style0 from "./OtherUserGroupTypeList.vue?vue&type=style&index=0&id=7d400d8f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d400d8f",
  null
  
)

export default component.exports